import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { component } from 'hoc'
import cn from 'classnames'
import Tooltip from 'components/tooltip'
import styles from './icon.styles'

const getIconClass = (classes, className, name, prefix, spin, stackLevel) =>
  cn(classes.main, prefix, spin ? 'fa-spin' : '', `fa-${name}`, 'fa-fw', className, stackLevel)

const getIcon = (classes, className, children, stackedIcon, stackedIconClass, prefix, spin) => (
  stackedIcon ?
    <span className="fa-stack">
      <i className={getIconClass(classes, className, children, prefix, false, 'fa-stack-1x')} />
      <i className={getIconClass(classes, stackedIconClass, stackedIcon, prefix, spin, 'fa-stack-2x')} />
    </span>
    : <i className={getIconClass(classes, className, children, prefix, spin)} />
)

const Icon = ({
  className,
  tooltip,
  tooltipPlacement,
  children,
  stackedIcon,
  stackedIconClass,
  prefix,
  classes,
  spin,
}) => {
  return (
    <Fragment>
      {!!tooltip &&
        <Tooltip title={tooltip} placement={tooltipPlacement}>
          {getIcon(classes, className, children, stackedIcon, stackedIconClass, prefix || 'fal', spin)}
        </Tooltip>}
      {!!tooltip || getIcon(classes, className, children, stackedIcon, stackedIconClass, prefix || 'fal', spin)}
    </Fragment>
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  tooltip: PropTypes.any,
  tooltipPlacement: PropTypes.string,
  children: PropTypes.string,
  stackedIcon: PropTypes.string,
  stackedIconClass: PropTypes.string,
  prefix: PropTypes.string,
  spin: PropTypes.bool,
}

Icon.defaultProps = {
  className: undefined,
  classes: {},
  tooltip: undefined,
  tooltipPlacement: 'top',
  children: undefined,
  stackedIcon: undefined,
  stackedIconClass: undefined,
  prefix: undefined,
  spin: false,
}

export default component({ styles })(Icon)